import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaArrowCircleRight, FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import { API_URL_All } from '../../api';
//import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import { RankDiscountDetails } from './RankDiscountInfo';
import { CheckingTicket, FeedbackChecking } from '../tickets/Tickets';
import axiosInstance from '../../axiosInstance';
import { DEFAULT_PRICE_TYPE_NAME, resolveDefaultPriceTypeName } from '../../libs/contact-price-type';
import { fetchDefaultCustomerPriceTypeName } from '../../libs/customer-price-type';
import { resolveOrderProductId } from '../../libs/order-product-picker';
import OrderProductPickerModal from './OrderProductPickerModal';
import RecordCreatedMeta from '../RecordCreatedMeta';
import { validateMuaHoSupplierBeforeSave } from '../../libs/customerCreatePermission';


const OrderVatEditor = ({data, handleSearch }) => {
  const readOnly = Boolean(data?.readOnly);
  const showOrderSupplierSection = data?.showOrderSupplierSection === true;
  const muaHoSupplierReadOnly = Boolean(data?.muaHoSupplierReadOnly);
  const requireMuaHoSupplier = Boolean(data?.requireMuaHoSupplier);
  const canDeleteOrder = data?.canDeleteOrder !== false;
  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const inputDisabled = readOnly || isLocked;
  const supplierDisabled = inputDisabled || muaHoSupplierReadOnly;
  const [model, setModel] = useState({});
  const [customerCode, setCustomerCode] = useState('');
  const [productPickerModal, setProductPickerModal] = useState({
    show: false,
    detailIndex: -1,
    keyword: '',
    items: [],
    previewProductId: null,
    previewProductDetail: null,
    loadingList: false,
    loadingPreview: false,
    allowMultiple: false,
  });
  const productDetailCacheRef = useRef(new Map());
  const productSearchRequestRef = useRef(0);
  const productPreviewRequestRef = useRef(0);

  useEffect(() => {
    fetchOneRecord(data.id);
  }, [data]);

  const newProduct = {
    progressName: 'Đơn mới',
    checkingName: 'Chưa đối soát'
  };

  const getTitle = (model) => {
    var text = '';
    if (model.isDraft) text = "[Bản nháp] ";
    if (model.id) text += "Thông tin đơn hàng VAT";
    if (!model.id) text += "Đơn hàng VAT mới";

    return text;
  }

  const countOrderProducts = (details) => (details ?? []).filter((item) => (
    (item?.productId != null && item.productId !== '')
    || String(item?.productName ?? '').trim() !== ''
  )).length;

  const setModelStatus = (e) => {
    if (readOnly) return;
    var value = e.target.value;
    const newDetails = [...model.details];
    for (var i = 0; i < newDetails.length; i++) {
      var item = newDetails[i];
      if (!item.locking) {
        item.progressName = value;
      }
    }

    setModel({ ...model, statusName: value, details: newDetails });
  };

  const updateWarningMessage = (params) => {
    var weight = params.packageUnitValue;

    var totalWeight = params.details.reduce((sum, item) => sum + item.weight, 0);
    if (!totalWeight) totalWeight = 0;
    const rounded2 = Number((weight - totalWeight).toFixed(2));
    if (rounded2 !== 0) {
      params.warningWeight = 'Lệch: ' + rounded2 + 'kg';
    } else {
      params.warningWeight = '';
    }

    var size = params.packageUnitM3;
    var totalSize = 0;
    for (var i = 0; i < params.details.length; i++) {
      var item = params.details[i];
      var sizeItem = item.size;
      if (item.sizeX && item.sizeY && item.sizeZ) {
        sizeItem = (item.sizeX * item.sizeY * item.sizeZ) / 1000000;
      }
      if (!sizeItem) sizeItem = 0;
      totalSize += sizeItem;
    }

    const rounded = Number((size - totalSize).toFixed(2));
    if (rounded !== 0) {
      params.warningSize = 'Lệch: ' + rounded + 'm3';
    } else {
      params.warningSize = '';
    }
    setModel(params);
  };

  /** Tải danh sách sản phẩm theo /api/products/getProductByCustomerCode (giống OrderEditor). */
  const enrichModelWithCustomerProducts = async (m) => {
    const code = (m.customerCode ?? '').trim();
    if (!code) {
      return { ...m, customerProductList: [] };
    }
    try {
      const response = await axiosInstance.get('/api/products/getProductByCustomerCode', {
        params: { customerCode: code },
      });
      if (!response.data?.success) {
        toast.error(response.data?.message || 'Không tải được danh sách sản phẩm');
        return { ...m, customerProductList: [] };
      }
      return { ...m, customerProductList: response.data.data ?? [] };
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || error.message);
      return { ...m, customerProductList: [] };
    }
  };

  const fetchDefaultPriceTypeNameByContactId = async (contactId, lineName) => {
    if (!contactId || !lineName) return DEFAULT_PRICE_TYPE_NAME;

    try {
      const response = await axiosInstance.get('/api/contacts/getContact', {
        params: { id: contactId },
      });
      return resolveDefaultPriceTypeName(response.data?.data, lineName);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      return DEFAULT_PRICE_TYPE_NAME;
    }
  };

  const normalizeSearchText = (value) => String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const filterProductPickerItems = (keyword, products) => {
    const seenIds = new Set();
    // BE gộp SP cá nhân + user_product nên có thể trùng id → trùng rowKey trong picker.
    const list = (Array.isArray(products) ? products : []).filter((p) => {
      if (p?.id == null || seenIds.has(p.id)) return false;
      seenIds.add(p.id);
      return true;
    });
    const q = normalizeSearchText(keyword);
    if (!q) return list;
    return list
      .filter((p) => {
        const name = normalizeSearchText(p?.name);
        const code = normalizeSearchText(p?.code);
        const matchedProperty = (p?.properties ?? []).some((prop) => {
          const propertyCode = normalizeSearchText(prop?.code);
          const propertyValue = normalizeSearchText(prop?.propertiesValue);
          return propertyCode.includes(q) || propertyValue.includes(q);
        });
        return name.includes(q) || code.includes(q) || matchedProperty;
      });
  };

  const normalizeProductName = (value) => normalizeSearchText(value);

  const findCustomerProductByName = (products, productName) => {
    const normalizedName = normalizeProductName(productName);
    if (!normalizedName) return null;
    return (Array.isArray(products) ? products : []).find(
      (product) => normalizeProductName(product?.name) === normalizedName,
    ) ?? null;
  };

  const getProductDetailCached = async (productId) => {
    if (!productId) return null;
    const cached = productDetailCacheRef.current.get(Number(productId));
    if (cached) return cached;
    const response = await axiosInstance.get('/api/products/getProductDetailById', {
      params: { id: productId },
    });
    const detail = response.data?.data ?? null;
    if (detail?.id != null) {
      productDetailCacheRef.current.set(Number(detail.id), detail);
    }
    return detail;
  };

  const buildProductPickerRows = async (keyword, products, currentDetail) => {
    const filteredProducts = filterProductPickerItems(keyword, products);
    const details = await Promise.all(
      filteredProducts.map(async (product) => ({
        product,
        detail: await getProductDetailCached(product.id),
      })),
    );

    return details.flatMap(({ product, detail }) => {
      const parent = detail ?? product;
      const parentSelected =
        currentDetail?.productId != null &&
        String(currentDetail.productId) === String(product.id) &&
        (currentDetail?.productPropertyId == null || currentDetail?.productPropertyId === '');

      const parentRow = {
        rowKey: `parent-${product.id}`,
        product,
        propertyId: null,
        imagePath: parent?.imagePath ?? product?.imagePath,
        code: parent?.code ?? product?.code,
        subCode: '',
        name: parent?.name ?? product?.name,
        subName: '',
        price: parent?.price ?? product?.price,
        weight: parent?.weight ?? product?.weight,
        dimensions: formatPropertyDimensions(parent),
        isCurrent: parentSelected,
      };

      const propertyRows = (detail?.properties ?? []).map((prop, index) => ({
        rowKey: `property-${product.id}-${prop.id ?? index}`,
        product,
        propertyId: prop.id ?? null,
        imagePath: prop.imagePath ?? detail?.imagePath ?? product?.imagePath,
        code: prop.code ?? detail?.code ?? product?.code,
        subCode: detail?.code ?? product?.code ?? '',
        name: detail?.name ?? product?.name ?? 'Không có tên',
        subName: prop.propertiesValue ?? 'Thuộc tính',
        price: prop.price ?? detail?.price ?? product?.price,
        weight: prop.weight ?? detail?.weight ?? product?.weight,
        dimensions: propertyRowDimensionsDisplay(prop, detail ?? product),
        isCurrent:
          currentDetail?.productId != null &&
          String(currentDetail.productId) === String(product.id) &&
          currentDetail?.productPropertyId != null &&
          String(currentDetail.productPropertyId) === String(prop.id),
      }));

      return [parentRow, ...propertyRows];
    });
  };

  const previewProductInModal = async (product) => {
    if (!product?.id) {
      setProductPickerModal((prev) => ({
        ...prev,
        previewProductId: null,
        previewProductDetail: null,
        loadingPreview: false,
      }));
      return;
    }

    const requestId = productPreviewRequestRef.current + 1;
    productPreviewRequestRef.current = requestId;
    setProductPickerModal((prev) => ({
      ...prev,
      previewProductId: product.id,
      loadingPreview: true,
    }));

    try {
      const detail = await getProductDetailCached(product.id);
      if (productPreviewRequestRef.current !== requestId) return;
      setProductPickerModal((prev) => ({
        ...prev,
        previewProductId: product.id,
        previewProductDetail: detail,
        loadingPreview: false,
      }));
    } catch (error) {
      console.error(error);
      if (productPreviewRequestRef.current !== requestId) return;
      toast.error(error.response?.data?.message || error.message);
      setProductPickerModal((prev) => ({
        ...prev,
        loadingPreview: false,
      }));
    }
  };

  const closeProductPickerModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    productPreviewRequestRef.current += 1;
    setProductPickerModal({
      show: false,
      detailIndex: -1,
      keyword: '',
      items: [],
      previewProductId: null,
      previewProductDetail: null,
      loadingList: false,
      loadingPreview: false,
      allowMultiple: false,
    });
  };

  const handleOpenProductPicker = async (detailIndex) => {
    const detail = model.details?.[detailIndex];
    const allowMultiple = detail?.productId == null || detail?.productId === '';
    await openProductPickerModal(detailIndex, '', allowMultiple);
  };

  const openProductPickerModal = async (detailIndex, keyword = '', allowMultiple = false) => {
    setProductPickerModal((prev) => ({
      ...prev,
      show: false,
      allowMultiple,
      detailIndex,
      keyword,
      items: [],
      loadingList: true,
      loadingPreview: false,
    }));

    const refreshed = await enrichModelWithCustomerProducts(model);
    setModel(refreshed);

    const currentDetail = refreshed.details?.[detailIndex];
    const items = await buildProductPickerRows(keyword, refreshed.customerProductList, currentDetail);

    setProductPickerModal((prev) => ({
      ...prev,
      show: items.length > 0,
      allowMultiple,
      detailIndex,
      keyword,
      items,
      loadingList: false,
      previewProductId: null,
      previewProductDetail: null,
    }));
  };

  const handleProductPickerKeywordChange = async (keyword) => {
    const requestId = productSearchRequestRef.current + 1;
    productSearchRequestRef.current = requestId;
    const currentDetail = model.details?.[productPickerModal.detailIndex];
    const items = await buildProductPickerRows(keyword, model.customerProductList, currentDetail);
    // Gõ nhanh: bỏ kết quả của lượt tìm cũ trả về muộn.
    if (productSearchRequestRef.current !== requestId) return;
    setProductPickerModal((prev) => ({
      ...prev,
      keyword,
      items,
      loadingList: false,
    }));
  };

  const materializeOrderDetailFromProduct = (baseItem, productDetail, options = {}) => {
    const item = baseItem ?? {};
    var obj = { ...productDetail };
    obj.productId = obj.id;
    obj.productCode = obj.code;
    delete obj.id;
    obj.quantity = 1;
    obj.packageCount = 1;
    obj.money = obj.priceDeclare;

    var checkSize = obj.sizeX + obj.sizeY + obj.sizeZ;
    obj.size3 = (checkSize > 0);

    obj.providerName = obj.bestProviderName;
    obj.productLink = obj.bestProductLink;
    obj.productName = obj.name ?? item.productName;
    obj.parentProductSnapshot = buildParentSnapshotFromProductDto(obj);

    if (obj.properties?.length > 0) {
      const savedPid = options.propertyId ?? item.productPropertyId ?? obj.productPropertyId;
      if (savedPid != null && savedPid !== '') {
        const matchProp = obj.properties.find(
          (pr) => pr.id === savedPid || String(pr.id) === String(savedPid),
        );
        if (matchProp) {
          obj.productPropertyId = matchProp.id;
          applyProductPropertyToDetail(obj, matchProp);
        } else {
          obj.productPropertyId = null;
        }
      } else {
        obj.productPropertyId = null;
      }
    } else {
      obj.productPropertyId = null;
    }

    if (options.imagePath) {
      obj.imagePath = options.imagePath;
    }

    return { ...item, ...obj };
  };

  const loadSelectedProductToDetail = async (detailIndex, product, options = {}) => {
    if (!product?.id) return false;
    const newDetails = [...model.details];
    const item = newDetails[detailIndex];
    if (!item) return false;

    setIsLocked(true);
    try {
      const productDetail = options.productDetail ?? await getProductDetailCached(product.id);
      if (!productDetail) return false;
      newDetails[detailIndex] = materializeOrderDetailFromProduct(item, productDetail, options);
      const nextModel = { ...model, details: newDetails };
      setModel(nextModel);
      updateWarningMessage(nextModel);
      return true;
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      return false;
    } finally {
      setIsLocked(false);
    }
  };

  const chooseProductsFromPicker = async (rows) => {
    if (!rows?.length) return;
    const detailIndex = productPickerModal.detailIndex;
    setIsLocked(true);
    try {
      const details = [...(model.details ?? [])];
      const canReplace = detailIndex >= 0 && Boolean(details[detailIndex]);
      let replaced = false;
      const appended = [];
      for (const row of rows) {
        if (!row?.product?.id) continue;
        const productDetail = await getProductDetailCached(row.product.id);
        if (!productDetail) continue;
        const base = canReplace && !replaced ? { ...details[detailIndex] } : { ...newProduct };
        const built = materializeOrderDetailFromProduct(base, productDetail, {
          propertyId: row.propertyId,
          imagePath: row.imagePath,
        });
        if (canReplace && !replaced) {
          details[detailIndex] = built;
          replaced = true;
        } else {
          appended.push(built);
        }
      }
      if (!replaced && appended.length === 0) {
        toast.error('Không thêm được sản phẩm đã chọn.');
        return;
      }
      details.push(...appended);
      const nextModel = { ...model, details };
      setModel(nextModel);
      updateWarningMessage(nextModel);
      closeProductPickerModal();
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setIsLocked(false);
    }
  };

  const chooseProductFromPicker = async (detailIndex, product, imagePath) => {
    if (!product) return;
    await loadSelectedProductToDetail(detailIndex, product, { imagePath });
    closeProductPickerModal();
  };

  const chooseProductPropertyFromModal = async (detailIndex, product, propertyId, imagePath) => {
    if (!product) return;
    await loadSelectedProductToDetail(detailIndex, product, {
      productDetail: productPickerModal.previewProductDetail,
      propertyId,
      imagePath,
    });
    closeProductPickerModal();
  };

  const buildParentSnapshotFromProductDto = (p) => ({
    productCode: p.code,
    price: p.price,
    priceDeclare: p.priceDeclare,
    weight: p.weight,
    size: p.size,
    sizeX: p.sizeX,
    sizeY: p.sizeY,
    sizeZ: p.sizeZ,
    taxCode: p.taxCode,
    taxImport: p.taxImport,
    taxVat: p.taxVat,
    imagePath: p.imagePath,
    description: p.description,
    noteUser: p.note ?? '',
    size3: ((p.sizeX ?? 0) + (p.sizeY ?? 0) + (p.sizeZ ?? 0)) > 0,
  });

  const hydrateDetailsParentSnapshots = async (details) => {
    if (!details?.length) return details;
    const list = details.map((d) => ({ ...d }));
    const ids = [...new Set(list.map((d) => d.productId).filter((id) => id != null))];
    if (!ids.length) return list;
    const cache = new Map();
    await Promise.all(
      ids.map(async (pid) => {
        try {
          const p = await getProductDetailCached(pid);
          if (p?.id != null) cache.set(Number(pid), p);
        } catch (e) {
          console.error(e);
        }
      }),
    );
    for (const d of list) {
      if (d.productId == null || !cache.has(Number(d.productId))) continue;
      const p = cache.get(Number(d.productId));
      if (!d.parentProductSnapshot) {
        d.parentProductSnapshot = buildParentSnapshotFromProductDto(p);
      }
      if (!d.properties || d.properties.length === 0) {
        d.properties = p.properties ?? [];
      }
    }
    return list;
  };

  const formatPropertyDimensions = (row) => {
    if (!row) return '';
    const x = Number(row.sizeX ?? 0);
    const y = Number(row.sizeY ?? 0);
    const z = Number(row.sizeZ ?? 0);
    if (x + y + z > 0) return `${x}×${y}×${z}`;
    if (row.size != null && row.size !== '') return `${row.size} m³`;
    return '';
  };

  const propertyRowWeightDisplay = (prop, parentSpec) => {
    if (prop?.weight != null && prop.weight !== '') return prop.weight;
    if (parentSpec?.weight != null && parentSpec.weight !== '') return parentSpec.weight;
    return '—';
  };

  const propertyRowDimensionsDisplay = (prop, parentSpec) => {
    const own = formatPropertyDimensions(prop);
    if (own) return own;
    return (parentSpec && formatPropertyDimensions(parentSpec)) || '—';
  };

  const applyParentProductDefaults = (detail) => {
    if (!detail) return;
    const p = detail.parentProductSnapshot;
    if (!p) {
      detail.productPropertyId = null;
      return;
    }
    detail.productPropertyId = null;
    detail.productCode = p.productCode ?? detail.productCode;
    detail.price = p.price;
    detail.priceDeclare = p.priceDeclare;
    detail.weight = p.weight;
    detail.size = p.size;
    detail.sizeX = p.sizeX;
    detail.sizeY = p.sizeY;
    detail.sizeZ = p.sizeZ;
    detail.taxCode = p.taxCode;
    detail.taxImport = p.taxImport;
    detail.taxVat = p.taxVat;
    detail.imagePath = p.imagePath;
    detail.description = p.description ?? detail.description;
    detail.noteUser = p.noteUser ?? detail.noteUser;
    detail.size3 = !!p.size3;
    const quantity = detail.quantity ?? 1;
    detail.money = quantity * (detail.priceDeclare ?? 0);
    detail.moneyIn = quantity * (detail.priceIn ?? 0);
  };

  const getSelectedPropertyLabel = (item) => {
    if (item?.productPropertyId == null || item.productPropertyId === '') return '';
    const prop = (item.properties ?? []).find((p) => String(p.id) === String(item.productPropertyId));
    return String(prop?.propertiesValue ?? '').trim();
  };

  const applyProductPropertyToDetail = (detail, property) => {
    if (!detail || !property) return detail;

    detail.productPropertyId = property.id ?? detail.productPropertyId ?? null;
    detail.productCode = property.code ?? detail.productCode;
    detail.price = property.price ?? detail.price;
    detail.priceDeclare = property.priceDeclare ?? detail.priceDeclare;
    detail.weight = property.weight ?? detail.weight;
    detail.size = property.size ?? detail.size;
    detail.sizeX = property.sizeX ?? detail.sizeX;
    detail.sizeY = property.sizeY ?? detail.sizeY;
    detail.sizeZ = property.sizeZ ?? detail.sizeZ;
    detail.taxCode = property.taxCode ?? detail.taxCode;
    detail.taxImport = property.taxImport ?? detail.taxImport;
    detail.taxVat = property.taxVat ?? detail.taxVat;
    detail.imagePath = property.imagePath ?? detail.imagePath;
    detail.description = property.description || detail.description;
    detail.noteUser = property.note || detail.noteUser;

    var quantity = detail.quantity ?? 1;
    detail.money = quantity * (detail.priceDeclare ?? 0);
    detail.moneyIn = quantity * (detail.priceIn ?? 0);

    var checkSize = (detail.sizeX ?? 0) + (detail.sizeY ?? 0) + (detail.sizeZ ?? 0);
    detail.size3 = (checkSize > 0);

    return detail;
  };

  const getParentPropertyDisplay = (item) => {
    const p = item.parentProductSnapshot;
    if (p) return p;
    if (item.productPropertyId == null || item.productPropertyId === '') {
      return {
        productCode: item.productCode,
        price: item.price,
        priceDeclare: item.priceDeclare,
        weight: item.weight,
        size: item.size,
        sizeX: item.sizeX,
        sizeY: item.sizeY,
        sizeZ: item.sizeZ,
        taxCode: item.taxCode,
        taxImport: item.taxImport,
        taxVat: item.taxVat,
        description: item.description,
        noteUser: item.noteUser,
      };
    }
    return null;
  };

  const selectOrderDetailProperty = (detailIndex, propertyId) => {
    const newDetails = [...model.details];
    const detail = newDetails[detailIndex];
    if (!detail?.properties?.length) return;
    if (propertyId == null || propertyId === '') {
      applyParentProductDefaults(detail);
    } else {
      const prop = detail.properties.find(
        (pr) => pr.id === propertyId || String(pr.id) === String(propertyId),
      );
      if (prop) applyProductPropertyToDetail(detail, prop);
    }
    const nextModel = { ...model, details: newDetails };
    setModel(nextModel);
    updateWarningMessage(nextModel);
  };

  const setModelItem = async (name, e) => {
    if (readOnly) return;
    var value = e.target.value;
    var newModel = { ...model };
    newModel[name] = value;

    if (name === 'customerCode') {
      var thTag = e.target.closest('.th');
      if (thTag) {
        var selecteTag = thTag.querySelector('.item_selected');
        if (selecteTag && selecteTag.innerText === value && value) {
          setIsLocked(true);
          newModel.customerPriceTypeName = await fetchDefaultCustomerPriceTypeName(value, newModel.lineName || model.lineName || 'Line VAT');
          try {
            const params = {
              lineName: model.lineName,
              customerCode: value,
            };
            const response = await axiosInstance.get(`/api/contacts/getDefaultContact`, { params });

            var obj = response.data.data;
            if (obj.id) {
              const defaultPriceTypeName = resolveDefaultPriceTypeName(obj, model.lineName);
              const newDetails = [...(newModel.details ?? model.details ?? [])];
              for (var i = 0; i < newDetails.length; i++) {
                var item = newDetails[i];
                item.contactId = obj.id;
                item.contactCode = obj.code;
                item.contactName = obj.name;
                item.priceTypeName = defaultPriceTypeName;
              }

              newModel.details = newDetails;
            }

          } catch (error) {
            console.error(error);
            toast.error(error.message);
          }
          setIsLocked(false);
        } else {
          newModel.customerPriceTypeName = '';
        }
      }

    }

    if (name === 'customerCode') {
      newModel = await enrichModelWithCustomerProducts(newModel);
    }

    updateWarningMessage(newModel);
  }
  const setDetailsItem = async (index, name, e) => {
    if (readOnly) return;
    if (supplierDisabled && (name === 'providerName' || name === 'priceIn')) return;
    var value = e.target.value;
    if (value === 'on') value = e.target.checked;
    const newDetails = [...model.details];
    var item = newDetails[index];
    if (name === 'priceDeclare') {
      item.money = item.quantity * value
    }
    if (name === 'priceIn') {
      item.moneyIn = item.quantity * value
    }
    if (name === 'quantity') {
      item.money = value * item.priceDeclare;
      item.moneyIn = value * item.priceIn;
    }
    if (name === 'size') {
      item.sizeX = '';
      item.sizeY = '';
      item.sizeZ = '';
    }
    if (name === 'productName') {
      const matchedProduct = findCustomerProductByName(model.customerProductList, value);
      if (matchedProduct) {
        try {
          var productId = resolveOrderProductId(model.customerProductList, matchedProduct.name);
          if (!productId) {
            toast.error('Không xác định được sản phẩm. Vui lòng chọn từ danh sách gợi ý.');
          } else {
            await loadSelectedProductToDetail(index, { ...matchedProduct, id: productId });
            closeProductPickerModal();
            return;
          }
        } catch (error) {
          console.error(error);
          toast.error(error.message);
        }
      }
    }
    if (name === 'providerName') {
      var thTag = e.target.closest('.th');
      if (thTag) {
        var selecteTag = thTag.querySelector('.item_selected');
        if (selecteTag && selecteTag.innerText === value && value) {
          setIsLocked(true);
          try {
            const params = {
              refer: value,
              referId: item.productId,
            };
            const response = await axiosInstance.get(`/api/providers/getProductProviderByName`, { params });

            var obj = response.data.data;
            console.log(obj);
            //item.priceIn = obj.price;
            item.productLink = obj.productLink;
          } catch (error) {
            console.error(error);
            toast.error(error.message);
          }
          setIsLocked(false);
        }
      }

    }

    if (name === 'contactCode') {
      var thTag = e.target.closest('.th');
      if (thTag) {
        var selecteTag = thTag.querySelector('.item_selected');
        if (selecteTag && selecteTag.innerText === value && value) {
          item.contactId = e.target.dataset.text;
          item.priceTypeName = await fetchDefaultPriceTypeNameByContactId(item.contactId, model.lineName);
        }
      }

    }
    if (name !== 'productPropertyId') {
      item[name] = value;
    }
    setModel({ ...model, details: newDetails });
    updateWarningMessage({ ...model, details: newDetails });
  }

  const addOrderProduct = () => {
    if (readOnly) return;
    if (isLocked && !model.isAdmin) return;
    setModel({ ...model, details: [...(model.details ?? []), { ...newProduct }] });
  };

  const handleRemoveItem = (indexToRemove) => {
    if (readOnly) return;
    general.openConfirm(async () => {
      const newDetails = model.details.filter((_, i) => i !== indexToRemove);
      setModel({ ...model, details: newDetails });
    });
  };

  const handleDeletOrder = (e) => {
    if (!canDeleteOrder) {
      toast.warning("Bạn không có quyền xóa đơn hàng.");
      return;
    }
    if (!readOnly && isLocked) return;
    general.openConfirm(async () => {
      try {
        var modelData = {};
        var requestApi = `/api/import-orders/deleteOrder/${model.id}`;
        const response = await axiosInstance.put(requestApi, modelData);

        if (!response.data.success) {
          toast.error(response.data.message || "Không thể xóa đơn hàng.");
          return;
        }
        toast.success(response.data.message || "Đã xóa.");
        if (handleSearch) handleSearch();
        handleModalClose();

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    })
  };

  const handleTransformOrder = (e) => {
    if (readOnly) return;
    general.openConfirm(async () => {
      try {
        var modelData = {};
        var requestApi = `/api/import-orders/transformOrder/${model.id}`;
        const response = await axiosInstance.put(requestApi, modelData);

        if (!response.data.success) {
          toast.success(response.data.message);
          console.log(response.data);
          return;
        }
        console.log(response);
        toast.success(response.data.message);
        if (handleSearch) handleSearch();
        handleModalClose();

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }

    }, "Bạn có chắc chắn muốn chuyển bản nháp này thành đơn hàng chuẩn không?");
  };
  const handleModalClose = (e) => {
    closeModal(e);
  }
  const closeModal = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const handleSubmitForm = async(e) => {
    if (readOnly) return;
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    const supplierErr = validateMuaHoSupplierBeforeSave({
      requireMuaHoSupplier,
      model,
      vatMode: true,
    });
    if (supplierErr) {
      general.showFormError('.show .modal-body', supplierErr);
      return;
    }

    try {
      var updateOrderApi = `/api/import-orders/saveOrderVat`;
      const { customerProductList: _omitProducts, ...orderFields } = model;
      const dataModel = {
        ...orderFields,
        requireProvider: requireMuaHoSupplier || undefined,
        details: (model.details ?? []).map((item) => {
          const { properties, parentProductSnapshot, ...detail } = item;
          return {
            ...detail,
            productPropertyId: detail.productPropertyId ? Number(detail.productPropertyId) : null,
          };
        }),
      };
      const response = await axiosInstance.put(updateOrderApi, dataModel);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();

      window.dispatchEvent(new Event('refresh-operation-info'));
    } catch (error) {
      toast.error(error.message);
    }

  };

  const fetchOneRecord = async (orderId) => {
    const isNumber = Number.isFinite(orderId);
    if (!isNumber) {
      orderId = 0;
    }
    setModel({});
    try {
      var urlApi = `/api/import-orders/getOrder?id=${orderId}`;
      const response = await axiosInstance.get(urlApi);
      if (response.data?.success === false) {
        toast.error(response.data?.message || 'Không có quyền xem đơn hàng.');
        setShow(false);
        return;
      }
      var obj = response.data.data;
      var checkSize = obj.sizeX + obj.sizeY + obj.sizeZ;
      obj.size3 = (checkSize > 0);
      if (!obj.details) obj.details = [newProduct];
      if (obj.details) {
        obj.details.forEach((item, index) => {
          var checkSize = item.sizeX + item.sizeY + item.sizeZ;
          item.size3 = (checkSize > 0);
          item.locked = item.locking;
        });
      }

      if (!obj.id && data.isDraft) obj.isDraft = true;
      obj.lineName = 'Line VAT';
      if (!obj.customerPriceTypeName && obj.customerCode && obj.lineName) {
        obj.customerPriceTypeName = await fetchDefaultCustomerPriceTypeName(obj.customerCode, obj.lineName);
      }
      obj = await enrichModelWithCustomerProducts(obj);
      if (obj.details?.length) {
        obj.details = await hydrateDetailsParentSnapshots(obj.details);
        obj.details = await Promise.all(
          obj.details.map(async (item) => {
            if (item.priceTypeName || !item.contactId) return item;
            return {
              ...item,
              priceTypeName: await fetchDefaultPriceTypeNameByContactId(item.contactId, obj.lineName),
            };
          }),
        );
      }
      setModel(obj);
      setIsLocked(response.data.data.locked);
      setCustomerCode(response.data.data.customerCode);
      setShow(true);
    } catch (error) {
      console.error(error);
      setIsLocked(true);
      setModel({error: error.message});
      toast.error(error.message);
    }
  };
  const productCount = countOrderProducts(model.details);
  return (
    <Modal show={show} onHide={handleModalClose} size="xl">
      <div className="modal-dialog11 modal-lg11 position-relative">
        <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.orderCode && (<span className="record_id">Code: {model.orderCode}</span>)}
              <div>
                <h5 className="modal-title">
                  {getTitle(model)}
                  {productCount > 0 && (
                    <span className="ms-2 fw-normal text-muted">{productCount} sản phẩm</span>
                  )}
                </h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body mt-2">
              <div className="group-box" data-text="Thông tin chung">
                <div className="row">

                  <div className="col-md-2 mb-3">
                    <label className="form-label required">Tên đơn hàng</label>
                    <input type="text" name="name" className="form-control" placeholder="Nhập tên" data-required="Phải nhập mục này" disabled={readOnly} value={model.name ?? ''} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                  </div>
                  {model.isAdmin && (
                    <div className="col-md-2 mb-3">
                      {model.id && customerCode && !customerCode.includes('ZTO-VH') && (
                        <div>
                          <label className="form-label">&nbsp;</label>
                          <div>
                            <span>Mã khách hàng: </span>
                            <b>{model.customerCode ?? ''}</b>
                          </div>
                        </div>
                      )}
                      {(!model.id || (customerCode && customerCode.includes('ZTO-VH'))) && (
                        <div>
                          <label className="form-label required">Mã khách hàng</label>
                          <div className="th filter-editor">
                            <span className="filter-ib" data-source-url={API_URL_All + '/api/users/searchUserCodes'}>
                              <input type="text" name="customerCode" placeholder="Nhập mã khách hàng..." data-required="Phải nhập mục này." disabled={inputDisabled || model.locked} value={model.customerCode ?? ''} onChange={(e) => setModelItem('customerCode', e)} />
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {model.isAdmin && (
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Bảng giá khách hàng</label>
                      <div className="th filter-editor">
                        <span className="filter-ib" data-source-url={API_URL_All + '/api/levels/searchCustomerPriceTypes'}>
                          <input
                            type="text"
                            placeholder="Nhập tên bảng giá khách hàng"
                            disabled={inputDisabled || model.locked || !String(model.customerCode ?? '').trim() || !String(model.lineName ?? '').trim()}
                            data-refer={`${model.lineName ?? ''}#${model.customerCode ?? ''}`}
                            value={model.customerPriceTypeName ?? ''}
                            onChange={(e) => setModel({ ...model, customerPriceTypeName: e.target.value })}
                          />
                        </span>
                      </div>
                    </div>
                  )}
                  <div className="col-md-1 mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div>
                      <CheckingTicket checkingId={model.statusRateId} checkingName={model.statusRateName} />
                    </div>
                  </div>
                  {model.id > 0 && model.userRank > 0 && (
                    <div className="col-md-3 rounded">
                      <RankDiscountDetails rank={model.userRank} rankDiscountPercent={model.rankDiscountPercent} feeOriginal={model.feeOriginal} fee={model.fee} />
                    </div>
                  )}

                </div>

                <div className="row">
                </div>
                <div className="row">
                  <div className="col-6 col-md-3 mb-3">
                    <label className="form-label form-price" data-note="kg">Tổng khối lượng </label>
                    <div className="">
                      <input type="number" className="form-control form-price" placeholder="kg" name="packageUnitValue" disabled={inputDisabled || model.locked} value={model.packageUnitValue ?? ''} onChange={(e) => setModelItem('packageUnitValue', e)} />
                    </div>
                    <div className="fw-bold text-danger">{model.warningWeight}</div>
                  </div>
                  <div className="col-6 col-md-3 mb-3">
                    <label className="form-label form-price" data-note="m3">Tổng thể tích </label>
                    <div className="">
                      <input type="number" className="form-control form-price" placeholder="m3" name="packageUnitValue" disabled={inputDisabled || model.locked} value={model.packageUnitM3 ?? ''} onChange={(e) => setModelItem('packageUnitM3',e)} />
                    </div>
                    <div className="fw-bold text-danger">{model.warningSize}</div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Ghi chú</label>
                    {model.isAdmin && (
                      <div>
                        <input type="text" className="form-control" placeholder="Ghi chú" disabled={inputDisabled || model.locked} value={model.noteAdmin ?? ''} onChange={(e) => setModel({ ...model, noteAdmin: e.target.value })} />
                        {model.noteUser && (
                          <div>
                            <span>Lưu ý: </span>
                            <b>{model.noteUser}</b>
                          </div>
                        )}
                      </div>
                    )}

                    {!model.isAdmin && (
                      <div>
                        <input type="text" className="form-control" placeholder="Ghi chú" disabled={inputDisabled} value={model.noteUser ?? ''} onChange={(e) => setModel({ ...model, noteUser: e.target.value })} />
                        {model.noteAdmin && (
                          <div>
                            <span>Lưu ý: </span>
                            <b>{model.noteAdmin}</b>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">

                  <div className="col-md-12 mb-3">
                    <label className="form-label">Phương thức lấy hàng</label>
                    <div className="th filter-editor">
                      <span className="filter-ib" data-source-url={API_URL_All + '/api/import-orders/searchAddress'}><input type="text" placeholder="Nhập địa chỉ..." data-refer={model.customerCode} disabled={inputDisabled || model.locked} value={model.shippingMethod ?? ''} onChange={(e) => setModel({ ...model, shippingMethod: e.target.value })} /></span>
                    </div>
                  </div>
                </div>

                {model.id && model.isAdmin && (
                  <div className="row">


                    <div className="col-md-4 mb-3 flex-start">
                      <div className="th filter-check">
                        <span className="filter-ib"><input type="checkbox" checked={model.locked} onChange={(e) => setModel({ ...model, locked: e.target.checked })} /></span>
                        <label className="form-check-label">Khóa đơn hàng</label>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3 flex-start">
                      <div className="">
                        <span>Tổng phí: {general.formatNumber(model.fee)} vnđ</span>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="row">
                        <label className="form-label col-form-label col-4 ">Lưu trình</label>
                        <div className="col-8 th filter-editor">
                          <span className="filter-ib" data-source-key="list_status">
                            <input type="text" name="line" placeholder="Nhập lưu trình" disabled={inputDisabled || model.locked || model.isDraft} value={model.statusName ?? ''} onChange={(e) => setModelStatus(e)} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
                <div>
                  {model.details && model.details.map((item, index) => (
                    <div className="group-box p-0" key={index} data-text={`Sản phẩm ${index + 1}`}>
                      {model.details.length > 1 && !model.locked && !readOnly && (
                        <span className="close-i close-group" onClick={() => handleRemoveItem(index)}></span>
                      )}
                      <div className="group-body">
                        <div className="row">

                          <div className="col-md-2 mb-3">
                            <div className="product-img">
                              <div className="ratio ratio-1x1">
                                <img src={`${API_URL_All}/${item.imagePath}`} />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 mb-3 p-0">
                            <label className="form-label required">Tên sản phẩm</label>
                            <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`order-vat-editor-product-name-${index}`}
                                  autoComplete="off"
                                  disabled={inputDisabled || item.locking || item.locked || model.locked}
                                  data-refer={`${model.customerCode ?? ''}---`}
                                  placeholder="Nhập tên sản phẩm..."
                                  data-required="Phải nhập mục này."
                                  value={item.productName ?? ''}
                                  onChange={(e) => setDetailsItem(index, 'productName', e)}
                                  onClick={() => handleOpenProductPicker(index)}
                                />
                                {getSelectedPropertyLabel(item) && (
                                  <div className="small fst-italic text-truncate mt-1" title={getSelectedPropertyLabel(item)}>
                                    PL: {getSelectedPropertyLabel(item)}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="col-md-2 mb-3 p-0">
                            <label className="form-label">Mã sp</label>
                            <div className="">
                              <input type="text" className="form-control form-price" placeholder="Mã sp" disabled={true} value={item.productCode ?? ''} />
                            </div>
                          </div>
                          <div className="col-md-1 mb-3 p-0">
                            <label className="form-label">&nbsp;</label>
                            <div className="">
                              <CheckingTicket checkingId={item.checkingId} checkingName={item.checkingName} />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6 col-md-1 mb-3 p-0">
                            <label className="form-label" data-note="">Số lượng</label>
                            <div className="">
                              <input type="number" className="form-control form-price" placeholder="" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.quantity ?? ''} onChange={(e) => setDetailsItem(index, 'quantity', e)} />
                            </div>
                          </div>
                          <div className="col-6 col-md-2 mb-3 p-0">
                            <label className="form-label" data-note="vnđ">Giá nhập</label>
                            <div className="">
                              <input type="number" className="form-control form-price" placeholder="Giá nhập" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.price ?? ''} onChange={(e) => setDetailsItem(index, 'price', e)} />
                            </div>
                          </div>
                          <div className="col-6 col-md-3 mb-3 p-0">
                            <label className="form-label" data-note="vnđ">Giá khai báo</label>
                            <div className="">
                              <input type="number" className="form-control form-price" placeholder="Giá khai báo" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.priceDeclare ?? ''} onChange={(e) => setDetailsItem(index, 'priceDeclare', e)} />
                            </div>
                          </div>
                          <div className="col-6 col-md-3 mb-3 p-0">
                            <label className="form-label" data-note="vnđ">Thành tiền</label>
                            <div className="">
                              <input type="text" className="form-control form-price" placeholder="Thành tiền" disabled={true} value={general.formatNumberFull(item.money)} />
                            </div>
                          </div>

                          <div className="col-md-2 mb-3 p-0">
                            <label className="form-label" data-note="%">Thuế nhập</label>
                            <div className="">
                              <input type="number" className="form-control" placeholder="%" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.taxImport ?? ''} onChange={(e) => setDetailsItem(index, 'taxImport', e)} />
                            </div>
                          </div>

                          <div className="col-md-1 mb-3 p-0">
                            <label className="form-label" data-note="%">Thuế VAT</label>
                            <div className="">
                              <input type="number" className="form-control" placeholder="%" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.taxVat ?? ''} onChange={(e) => setDetailsItem(index, 'taxVat', e)} />
                            </div>
                          </div>
                        </div>

                        <div className="row d-none">
                          <div className=" col-md-12 mb-3 p-0">
                            <label className="form-label">Mô tả sản phẩm</label>
                            <textarea rows="3" type="text" className="form-control" placeholder="Mô tả sản phẩm" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.description ?? ''} onChange={(e) => setDetailsItem(index, 'description', e)} ></textarea>

                          </div>
                        </div>



                        <div className="row">
                          <div className="col-6 col-md-1 mb-3 p-0">
                            <label className="form-label">Số kiện</label>
                            <div className="">
                              <input type="number" className="form-control form-price" placeholder="Số kiện" disabled={inputDisabled || item.locking || item.locked || model.locked} name="packageNumbers" value={item.packageCount ?? ''} onChange={(e) => setDetailsItem(index, 'packageCount', e)} />
                            </div>
                          </div>
                          <div className="col-6 col-md-2 mb-3 p-0">
                            <label className="form-label form-price" data-note="kg">K.lượng</label>
                            <div className="">
                              <input type="number" className="form-control form-price" placeholder="kg" name="packageUnitValue" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.weight ?? ''} onChange={(e) => setDetailsItem(index, 'weight', e)} />
                            </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3 p-0">
                            <div className="size-options lable-size">
                              <ul>
                                <li data-for={`size_${index}`} className={item.size3 ? '' : 'active'}>
                                  <span className="form-label" data-note="m3">Thể tích</span>
                                </li>
                                <li data-for={`size3_${index}`} className={item.size3 ? 'active' : ''}>
                                  <span className="form-label" data-note="dài x rộng x cao (cm)">Kích thước</span>
                                </li>
                              </ul>
                              <i className="fa-solid fa-caret-down"></i>
                            </div>
                            <label className="form-label">&nbsp;</label>
                            <div id={`size_${index}`} className={item.size3 ? 'd-none' : ''}>
                              <input type="number" name="size" className="form-control" placeholder="m3" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.size ?? ''} onChange={(e) => setDetailsItem(index, 'size', e)} />
                            </div>
                            <div id={`size3_${index}`} className={item.size3 ? 'size-3' : 'size-3 d-none'}>
                              <input type="number" className="form-control" placeholder="dài cm" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.sizeX ?? ''} onChange={(e) => setDetailsItem(index, 'sizeX', e)} />
                              <input type="number" className="form-control" placeholder="rộng cm" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.sizeY ?? ''} onChange={(e) => setDetailsItem(index, 'sizeY', e)} />
                              <input type="number" className="form-control" placeholder="cao cm" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.sizeZ ?? ''} onChange={(e) => setDetailsItem(index, 'sizeZ', e)} />
                            </div>
                          </div>

                          <div className="col-6 col-md-3 mb-3 p-0">
                            <label className="form-label" data-note="vnđ">Giá bảo hiểm</label>
                            <div className="">
                              <input type="number" className="form-control form-price" placeholder="Giá bảo hiểm" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.priceInsurance ?? ''} onChange={(e) => setDetailsItem(index, 'priceInsurance', e)} />
                            </div>
                          </div>
                          <div className="col-md-3 mb-3 p-0">
                            <label className="form-label" data-note="vnđ">Phụ phí</label>
                            <div className="">
                              <input type="number" className="form-control" placeholder="Phụ phí" disabled={inputDisabled || item.locking || item.locked || model.locked || !model.isAdmin} value={item.feeSurcharge ?? ''} onChange={(e) => setDetailsItem(index, 'feeSurcharge', e)} />
                            </div>
                          </div>
                        </div>


                        <div className="row">

                          <div className="col-md-3 mb-3 p-0">
                            <label className="form-label">Mã vận đơn TQ</label>
                            <div className="">
                              <input type="text" className="form-control" placeholder="Mã vận đơn TQ" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.cnCode ?? ''} onChange={(e) => setDetailsItem(index, 'cnCode', e)} />
                            </div>
                          </div>
                          <div className="col-md-3 mb-3 p-0">
                            <label className="form-label">Mã vận đơn VN</label>
                            <div className="">
                              <input type="text" className="form-control" placeholder="Mã vận đơn VN" disabled={inputDisabled || item.locking || item.locked || model.locked || !model.isAdmin} value={item.vnCode ?? ''} onChange={(e) => setDetailsItem(index, 'vnCode', e)} />
                            </div>
                          </div>
                          <div className="col-md-3 mb-3 p-0">
                            <label className="form-label">Lưu trình</label>
                            <div className="th filter-editor">
                              <span className="filter-ib" data-source-key="list_status">
                                <input type="text" name="line" placeholder="Nhập lưu trình" disabled={inputDisabled || item.locking || item.locked || model.locked || !model.isAdmin || model.isDraft} value={item.progressName ?? ''} onChange={(e) => setDetailsItem(index, 'progressName', e)} />
                              </span>
                            </div>
                          </div>
                        </div>

                        {!model.isAdmin && (
                          <div className="row">
                            <div className="col-md-12 mb-3 p-0">
                              <label className="form-label">Ghi chú sản phẩm</label>
                              <div className="">
                                <input type="text" className="form-control" placeholder="Ghi chú" disabled={inputDisabled || item.locked || model.locked} value={item.noteUser ?? ''} onChange={(e) => setDetailsItem(index, 'noteUser', e)} />
                              </div>
                              {item.noteAdmin && (
                                <div className="">
                                  <span>Lưu ý: </span>
                                  <b>{item.noteAdmin}</b>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {model.isAdmin && (
                          <div className="row">
                            <div className="col-md-9 mb-3 p-0">
                              <label className="form-label">Ghi chú sản phẩm</label>
                              <div className="">
                                <input type="text" className="form-control" placeholder="Ghi chú" disabled={inputDisabled || item.locking || item.locked || model.locked} value={item.noteAdmin ?? ''} onChange={(e) => setDetailsItem(index, 'noteAdmin', e)} />
                              </div>
                              {item.noteUser && (
                                <div className="">
                                  <span>Lưu ý: </span>
                                  <b>{item.noteUser}</b>
                                </div>
                              )}
                            </div>
                            {item.id && (
                              <div className="col-md-3 mb-3">
                                <label className="form-label">&nbsp;</label>
                                <div className="th filter-check d-flex align-items-center">
                                  <span className="filter-ib"><input type="checkbox" checked={item.locking || model.locked} onChange={(e) => setDetailsItem(index, 'locking', e)} /></span>
                                  <label className="form-check-label">Khóa sản phẩm</label>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {model.isAdmin && (
                        <div>
                          <div className="area-provider">
                            {showOrderSupplierSection && requireMuaHoSupplier && (
                              <div className="row m-0 product_provider">
                                <div className="col-md-6 mb-3 p-0">
                                  <label className="form-label" title={`careId: ${model.careId ?? ''}`}>Nhà cung cấp</label>
                                  <div className="th filter-editor">
                                    <span className="filter-ib" data-source-url={API_URL_All + '/api/providers/searchProductProviderNames'}><input type="text" name="providerName" disabled={supplierDisabled || item.locking || item.locked || model.locked} data-refer={item.productName} placeholder="Nhập tên nhà cung cấp..." {...(requireMuaHoSupplier && !supplierDisabled && String(item.productName ?? '').trim() ? { 'data-required': 'Đơn mua hộ bắt buộc chọn nhà cung cấp.' } : {})} value={item.providerName ?? ''} onChange={(e) => setDetailsItem(index, 'providerName', e)} /></span>
                                  </div>
                                </div>
                                <div className="col-6 col-md-2 mb-3 p-0">
                                  <label className="form-label" data-note="CNY">Giá NCC</label>
                                  <div className="">
                                    <input type="text" className="form-control form-price" placeholder="Giá NCC" disabled={supplierDisabled || item.locking || item.locked || model.locked} onChange={(e) => setDetailsItem(index, 'priceIn', e)} value={item.priceIn ?? ''} />
                                  </div>
                                </div>
                                <div className="col-2 mb-3 p-0">
                                  <label className="form-label" data-note="CNY">Thành tiền NCC</label>
                                  <div className="">
                                    <input type="text" className="form-control form-price" placeholder="Thành tiền NCC" disabled={true} value={general.formatNumberFull(item.moneyIn)} />
                                  </div>
                                </div>
                                <div className="col-10 col-md-1 mb-3 p-0">
                                  <label className="form-label">&nbsp;</label>
                                  <div className="p-1">
                                    {item.productLink && item.productLink.length > 20 && (<a href={item.productLink} target="_black">Link sp</a>)}

                                  </div>
                                </div>
                                <div className="col-1 mb-3 p-0">
                                  <label className="form-label">&nbsp;</label>
                                  <div className="flex-end">
                                    {item.providerId && (<FeedbackChecking commentId={item.commentId} />) }                                  
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="row m-0">
                              <div className="col-md-6 mb-3 p-0">
                                <label className="form-label">
                                  <span>Đối tác </span>
                                </label>
                                <div>
                                  <input type="text" className="form-control d-none" placeholder="..." disabled={true} value={item.contactName ?? ''} />

                                  <div className="th filter-editor">
                                    <span className="filter-ib" data-source-key="code" data-source-text="id" data-source-url={API_URL_All + '/api/contacts/searchContactNames'}><input type="text" data-refer={model.lineName} placeholder="Nhập mã đối tác..." value={item.contactCode ?? ''} onChange={(e) => setDetailsItem(index, 'contactCode', e)} /></span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2 mb-3 p-0">
                                <label className="form-label">
                                  <span>Bảng giá</span>
                                </label>
                                <div className="th filter-editor">
                                  <span className="filter-ib" data-source-url={API_URL_All + '/api/contacts/searchContactPriceTypes'}>
                                    <input type="text" placeholder="Nhập tên bảng giá" data-refer={`${model.lineName}#${item.contactId}`} value={item.priceTypeName ?? ''} onChange={(e) => setDetailsItem(index, 'priceTypeName', e)} />
                                  </span>
                                </div>
                              </div>
                              <div className="col-6 col-md-2 mb-3 p-0">
                                <label className="form-label" data-note="vnđ">Phụ phí đối tác</label>
                                <div className="">
                                  <input type="number" className="form-control form-price" placeholder="Phụ phí" disabled={inputDisabled || model.locked || !model.isAdmin} value={item.contactFeeSurcharge ?? ''} onChange={(e) => setDetailsItem(index, 'contactFeeSurcharge', e)} />
                                </div>
                              </div>
                              <div className="col-6 col-md-2 mb-3 p-0">
                                <label className="form-label">Mã bao</label>
                                <div className="">
                                  <input type="text" className="form-control" disabled={inputDisabled || model.locking} placeholder="Nhập mã bao" value={item.sackCode ?? ''} onChange={(e) => setDetailsItem(index, 'sackCode', e)} />
                                </div>
                              </div>
                            </div>
                            <div className="pb-2">
                              {model.id > 0 && (
                                <div>
                                  <span>Xếp hạng: {model.userRank}</span>
                                  <span> - Hàng nặng: {general.formatNumber(item.feeWeightBase)}/kg </span>
                                  <span> - Cồng kềnh: {general.formatNumber(item.feeSizeBase)}/m3 </span>
                                  <span> - Phí đơn hàng: {general.formatNumber(item.fee)} vnđ </span>
                                  {item.feeOriginal != null && (
                                    <span> - Phí gốc: {general.formatNumber(item.feeOriginal)} vnđ - Chiết khấu: {general.formatNumber(Math.max(0, item.feeOriginal - (item.fee || 0))) || 0} vnđ </span>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>


                        </div>
                      )}




                    </div>
                  ))}
                  {!readOnly && !(isLocked && !model.isAdmin) && (
                    <button type="button" className="small-btn d-inline-flex align-items-center gap-1" onClick={addOrderProduct}>
                      <FaPlus size={12} aria-hidden />
                      Thêm sản phẩm
                    </button>
                  )}
                </div>

            </div>
            <RecordCreatedMeta record={model} />
            <div className="modal-footer justify-content-between align-items-center">
              <div>
                {model.isAdmin && model.id && canDeleteOrder && (readOnly || !isLocked) && (
                  <div className="d-flex flex-wrap gap-2 align-items-center">
                    <button type="button" className="btn-small d-inline-flex align-items-center gap-1" onClick={() => handleDeletOrder()}>
                      <FaTrash size={13} aria-hidden />
                      Xóa
                    </button>
                    {!readOnly && !isLocked && model.isDraft && (
                      <button type="button" className="btn-small d-inline-flex align-items-center gap-1" onClick={() => handleTransformOrder()}>
                        <FaArrowCircleRight size={13} aria-hidden />
                        Chuyển đơn chuẩn
                      </button>
                    )}
                  </div>
                )}
              </div>
              <div>
                {!readOnly ? (
                  <button type="submit" className="btn-sm btn btn-primary d-inline-flex align-items-center gap-1">
                    <FaSave size={14} aria-hidden />
                    {model.isDraft ? 'Lưu đơn nháp' : 'Lưu đơn'}
                  </button>
                ) : (
                  <button type="button" className="btn-sm btn btn-secondary d-inline-flex align-items-center gap-1" onClick={handleModalClose}>
                    <FaTimes size={14} aria-hidden />
                    Đóng
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
      <OrderProductPickerModal
        show={productPickerModal.show}
        keyword={productPickerModal.keyword}
        customerCode={model.customerCode}
        rows={productPickerModal.items}
        loadingList={productPickerModal.loadingList}
        locked={isLocked || readOnly}
        allowMultiple={productPickerModal.allowMultiple}
        onClose={closeProductPickerModal}
        onSearch={handleProductPickerKeywordChange}
        onChooseRows={chooseProductsFromPicker}
        onChooseRow={(row) => {
          if (row.propertyId != null) {
            chooseProductPropertyFromModal(productPickerModal.detailIndex, row.product, row.propertyId, row.imagePath);
            return;
          }
          chooseProductFromPicker(productPickerModal.detailIndex, row.product, row.imagePath);
        }}
      />
    </Modal>
  );
};

export default OrderVatEditor;
